import * as React from 'react';
import { CheckboxField } from '@gandi/form/FinalForm';
import { useTranslator } from '@gandi/translate';
import { Base } from '@gandi/ui';
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultRegistrationCheckbox = baseProps => {
  const {
    __
  } = useTranslator();
  return /*#__PURE__*/_jsx(Base, {
    ...baseProps,
    children: /*#__PURE__*/_jsx(CheckboxField, {
      name: "default_registration",
      children: __('Apply this template to my future registrations.')
    })
  });
};
export default DefaultRegistrationCheckbox;